class Timer {
  #state;
  #timeStarted;
  #timePaused;
  #currentTime;

  constructor() {
    this.#state = "off";
    this.#timeStarted = 0;
    this.#timePaused = 0;
    this.#currentTime = 0;
  }

  start = () => {
    if (this.#state !== "off") return;
    this.#state = "on";
    this.#timeStarted = performance.now();
  };

  pause = () => {
    if (this.#state !== "on") return;
    this.#state = "paused";
    this.#timePaused = performance.now();
    this.#currentTime = (this.#timePaused - this.#timeStarted) / 1000;
  };

  resume = () => {
    if (this.#state !== "paused") return;
    this.#state = "on";
    this.#timeStarted += performance.now() - this.#timePaused;
  };

  reset = () => {
    this.#state = "off";
    this.#currentTime = 0;
  };

  getTime = () => {
    if (this.#state === "on") {
      this.#currentTime = (performance.now() - this.#timeStarted) / 1000;
    }
    return this.#currentTime.toFixed(2);
  };
}

export default Object.freeze(Timer);
